import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilterCategory, FiltersValuesMap } from '../models/list-filter-types';
import { fetchFiltersValuesFromQuery } from '../utils/list-filter-utils';

export const initialState: Fields = {
  filtersValues: fetchFiltersValuesFromQuery(),
};

export interface Fields {
  selectedFilter?: FilterCategory;
  filtersValues: FiltersValuesMap;
}

const reducer = createSlice({
  name: 'asset-list-filters',
  initialState,
  reducers: {
    setSelectedFilter: (state, action: PayloadAction<FilterCategory>) => {
      state.selectedFilter = action.payload;
    },
    setFiltersValues: (state, action: PayloadAction<FiltersValuesMap>) => {
      state.filtersValues = action.payload;
    },
  },
});

export const { setSelectedFilter, setFiltersValues } = reducer.actions;

export default reducer.reducer;
